var React = require('react');

function Visibility (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21 14C16 14 11.73 17.11 10 21.5C11.73 25.89 16 29 21 29C26 29 30.27 25.89 32 21.5C30.27 17.11 26 14 21 14ZM21 26.5C18.24 26.5 16 24.26 16 21.5C16 18.74 18.24 16.5 21 16.5C23.76 16.5 26 18.74 26 21.5C26 24.26 23.76 26.5 21 26.5ZM21 18.5C19.34 18.5 18 19.84 18 21.5C18 23.16 19.34 24.5 21 24.5C22.66 24.5 24 23.16 24 21.5C24 19.84 22.66 18.5 21 18.5Z","fill":"#4C3371","key":1})]);
}

Visibility.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Visibility;

Visibility.default = Visibility;
